import { gql } from '@apollo/client';

export const GetBlockedUsersQueryName = 'GetBlockedUsers';

export const GET_BLOCKED_USERS_QUERY = gql`
  query ${GetBlockedUsersQueryName} {
    getBlockedUsers {
      userId
      displayName
      blockedAt
    }
  }
`;
